import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engfinity2025',
  templateUrl: './engfinity2025.component.html',
  styleUrls: ['./engfinity2025.component.scss']
})
export class Engfinity2025Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
